import React, { useEffect } from 'react';
import { Redirect } from 'react-router'
import api from '../api/index.js';

export default (props) => {
	useEffect(() => {
		api.auth.logout();
	});

	return  <Redirect to="/" />
}